import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from "react";

var IconImgLoading = /*#__PURE__*/function (_React$Component) {
  _inherits(IconImgLoading, _React$Component);

  var _super = _createSuper(IconImgLoading);

  function IconImgLoading(props) {
    _classCallCheck(this, IconImgLoading);

    return _super.call(this, props);
  }

  _createClass(IconImgLoading, [{
    key: "render",
    value: function render() {
      var isServerRendering = function () {
        try {
          return !((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && document !== undefined);
        } catch (e) {
          return true;
        }
      }();

      var prefixCls = !isServerRendering && window.ARCO_PREFIXCLS ? window.ARCO_PREFIXCLS : this.props.prefixCls;
      var className = this.props && this.props.className ? this.props.className + " " : "";

      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        className: className + "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-img-loading".replace(/arco-/g, prefixCls + "-")
      });

      if (this.props.spin) {
        props.className = props.className + " " + prefixCls + "-icon-loading";
      }

      delete props.prefixCls;
      delete props.spin;
      delete props.isIcon;
      return /*#__PURE__*/React.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        viewBox: "0 0 23 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-img-loading"
      }, props), /*#__PURE__*/React.createElement("path", {
        d: "M14.857 2.971L12.324 7.36a1.585 1.585 0 00.58 2.166l2.388 1.378a1.585 1.585 0 01.581 2.165L9.56 24.002a1.332 1.332 0 00.487 1.819l.36.208c.491.283 1.095.283 1.586 0l9.958-5.748c.49-.283.792-.806.792-1.373V7.409c0-.566-.302-1.09-.792-1.373l-5.876-3.391a.892.892 0 00-1.218.326z",
        fill: "#EAECF6"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7.451 15.338l2.54 1.466a1.585 1.585 0 01.58 2.165l-2.186 3.787a1.586 1.586 0 01-2.166.58l-5.426-3.13A1.585 1.585 0 010 18.831V7.334c0-.567.302-1.09.793-1.373L10.75.212a1.585 1.585 0 011.585 0l.36.209c.637.367.856 1.181.488 1.818L6.871 13.173a1.585 1.585 0 00.58 2.165z",
        fill: "#D9DBE5"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 11.056,
        cy: 12.794,
        r: 5.423,
        fill: "#FAFAFD"
      }));
    }
  }]);

  return IconImgLoading;
}(React.Component);

IconImgLoading.defaultProps = {
  isIcon: true,
  prefixCls: "arco"
};
export default IconImgLoading;